var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchEdgeNodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78574 3.18296C4.83148 3.18277 2.90098 3.18329 0.970473 3.18172C0.622645 3.18143 0.483226 3.03269 0.501594 2.69837C0.513909 2.47421 0.628153 2.35221 0.824493 2.32026C0.902011 2.30764 0.982427 2.3153 1.06152 2.3153C3.42718 2.31525 5.79284 2.3154 8.15851 2.31552C8.24447 2.31553 8.33044 2.31552 8.43275 2.31552C8.42154 2.18819 8.34056 2.13756 8.28432 2.07495C7.97423 1.72964 7.65555 1.39338 7.34986 1.04356C7.10753 0.766255 7.16695 0.409901 7.4622 0.282332C7.63248 0.208755 7.77797 0.266835 7.89642 0.39509C8.576 1.13095 9.25052 1.87239 9.9294 2.60903C10.0225 2.71007 10.0244 2.78666 9.92988 2.88908C9.25619 3.61917 8.58825 4.3556 7.91304 5.08399C7.71454 5.29812 7.49566 5.30058 7.32314 5.11745C7.15091 4.93464 7.1537 4.67223 7.34842 4.45091C7.6333 4.12711 7.9287 3.81435 8.2187 3.49588C8.2841 3.42407 8.34572 3.34816 8.40907 3.27413C8.40446 3.24374 8.39986 3.21334 8.39525 3.18295C7.86666 3.18295 7.33807 3.18295 6.78574 3.18296Z",
    fill: "url(#paint0_linear_12392_99189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08772 7.10991C6.55253 7.10988 7.99357 7.10979 9.43461 7.11009C9.51373 7.11011 9.59402 7.10563 9.67172 7.11684C9.87522 7.14619 10.0033 7.30281 9.99994 7.50834C9.9965 7.71903 9.87724 7.83886 9.67727 7.88081C9.59361 7.89836 9.5038 7.88952 9.41679 7.88954C7.10479 7.89002 4.79279 7.89009 2.48079 7.89023C2.34024 7.89024 2.19968 7.89023 1.98193 7.89023C2.36642 8.26163 2.69821 8.58074 3.0281 8.90173C3.11201 8.98337 3.20557 9.05863 3.25457 9.16871C3.33701 9.3539 3.3082 9.52309 3.151 9.6534C3.0008 9.77791 2.83295 9.78123 2.67004 9.66813C2.61866 9.63246 2.57125 9.59019 2.5266 9.54646C1.88221 8.91529 1.24052 8.28146 0.592989 7.65343C0.480578 7.5444 0.460837 7.47194 0.585161 7.35182C1.24519 6.7141 1.89667 6.06787 2.55179 5.42525C2.67382 5.30556 2.81028 5.21477 2.99536 5.26336C3.30706 5.34519 3.40393 5.70249 3.16907 5.95137C2.91105 6.22481 2.63791 6.48479 2.36554 6.74477C2.25847 6.84699 2.13566 6.93335 2.02002 7.02693C2.03491 7.05459 2.04979 7.08225 2.06467 7.10992C3.06443 7.10992 4.06419 7.10992 5.08772 7.10991Z",
    fill: "url(#paint1_linear_12392_99189)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12392_99189",
    x1: -0.5,
    y1: 3.01316,
    x2: 12.2372,
    y2: 3.48768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DC7B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12392_99189",
    x1: -0.5,
    y1: 7.73684,
    x2: 12.2331,
    y2: 8.26392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DC7B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27281"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEdgeNodes);
export default __webpack_public_path__ + "static/media/search-edge-nodes.1cad74865f1afb8d6f5cb0fc4a607566.svg";
export { ForwardRef as ReactComponent };